import { z } from "zod";

export const PROJECT_STATES = ["active", "inactive", "archived"] as const;
export const PROJECT_PREFERENCE = ["all", "plan-based"] as const;
export type ProjectPreference = (typeof PROJECT_PREFERENCE)[number];

export const getProjectsQuerySchema = z.object({
	clientId: z.string().optional(),
	limit: z.string().default("4000"),
	state: z.string().default("active").pipe(z.enum(PROJECT_STATES)),
	latitude: z.string().optional(),
	longitude: z.string().optional(),
	preference: z.enum(PROJECT_PREFERENCE).default("all"),
});

export type GetProjectsQuerySchema = z.input<typeof getProjectsQuerySchema>;
